<template>
    <a-result title="Plataforma en Mantenimiento">
    </a-result>
</template>